export default "__VITE_ASSET__59534623__"